import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
import { ClarificationMessage } from '@/types/clarification';
import { formatClarificationDate, formatUserName } from './utils';
import InlineEditForm from './InlineEditForm';

interface EditableReplyProps {
  reply: ClarificationMessage;
  clarificationId: string;
  currentUserId: string | undefined;
  canEdit: boolean;
  onUpdate: (id: string, content: string, messageId?: string) => Promise<void>;
}

const EditableReply: React.FC<EditableReplyProps> = ({
  reply,
  clarificationId,
  currentUserId,
  canEdit,
  onUpdate,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div className="border-l-2 border-gray-200 pl-4">
      <div className="space-y-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-gray-900">
            {formatUserName(reply.user, currentUserId)}
          </span>
          <span className="text-xs text-gray-500">
            {formatClarificationDate(reply.created_at)}
          </span>
        </div>
        {isEditing ? (
          <InlineEditForm
            initialContent={reply.content}
            onSave={async content => {
              await onUpdate(clarificationId, content, reply.id);
              setIsEditing(false);
            }}
            onCancel={() => setIsEditing(false)}
          />
        ) : (
          <>
            <p className="text-sm whitespace-pre-wrap text-gray-900">
              {reply.content}
            </p>
            {canEdit && (
              <button
                type="button"
                onClick={() => setIsEditing(true)}
                className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1 px-2 py-1 rounded hover:bg-blue-50 transition-colors mt-1"
              >
                <Pencil className="h-3 w-3" />
                Edit
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EditableReply;
